/*
 * @Descripttion: 模态框
 * @version: 1.0
 * @Author: zhanmei
 * @Date: 2020-08-18 10:55:42
 * @LastEditors: zhanmei
 * @LastEditTime: 2020-08-26 18:40:12
 */

var $ = require('jQuery');
var Component = require('../Component');
var template = require('../../template/modal-window.html');

var ModalWin = function (options) {
    (function (self) {

        var defaults = {
            template: template
        };
        $.extend(defaults, options);
        Component.call(self, defaults);
    })(this);
};
ModalWin.prototype = Object.create(Component.prototype);

/**
 * @msg: 模态框显示
 * @param {Object} 输入参数
 * { 
 *    title:'消息提醒',
      content: "是否删除选中消息?",    // 必传
      showCancel:true/false,
      cancelText:'取消',
      confirmText:'确定',
      success:function(res){
        if (res.confirm) {
          console.log('用户点击确定')
        } else if (res.cancel) {
          console.log('用户点击取消')
        }
      },
      fail:function(){

      }
 * }
 * @return null 
 */
ModalWin.prototype.show = function (opt) {
    var self = this;
    var text = opt.content;
    if (!text) {
        opt.fail && opt.fail();
        return;
    }
    this._element.find('.im-modal-content').text(text);
    this._element.find('.im-modal-title').text(opt.title);
    opt.cancelText && this._element.find('.im-modal-cancel').text(opt.cancelText);
    opt.confirmText && this._element.find('.im-modal-submit').text(opt.confirmText);
    if (opt.showCancel) {
        this._element.find('.im-modal-cancel').show();
    }
    Component.prototype.show.call(this);
    this._element.find('.im-modal-handler').on('click', function (e) {
        console.log('im-modal-handler click e', e);
        var target = e && e.target ? e.target.className : '';
        if (target && target !== '') {
            var res = target == 'im-modal-submit' ? { confirm: true } : target == 'im-modal-cancel' ? { cancel: true } : {}
            opt.success && opt.success(res);
            if (['im-modal-submit', 'im-modal-cancel'].indexOf(target) != -1) {
                self.hide();
            }
        }
    })
};
/**
 * @msg: 模态框隐藏
 * @param null
 * @return null 
 */
ModalWin.prototype.hide = function () {
    this._element.find('.im-modal-handler').off('click');
    Component.prototype.hide.call(this);

};

module.exports = ModalWin;
